var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#040308"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06463 33.9935L16.513 32.6433C16.513 32.4909 16.513 32.3384 16.513 32.1751C16.513 30.814 16.6746 29.4856 16.9763 28.2224L12.5043 28.9411C13.7112 21.0576 19.2824 14.6222 26.6315 12.2267V16.8C27.9677 16.2338 29.3901 15.8418 30.8772 15.6458V7C18.0647 8.0889 8 18.9451 8 32.1751C8 32.785 8.02153 33.3947 8.06463 33.9935Z",
    fill: "#F1BE48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9354 33.9935L49.4871 32.6433C49.4871 32.4909 49.4871 32.3384 49.4871 32.1751C49.4871 30.814 49.3254 29.4856 49.0237 28.2224L53.4958 28.9411C52.2888 21.0576 46.7177 14.6222 39.3687 12.2267V16.8C38.0324 16.2338 36.6101 15.8418 35.123 15.6458V7C47.9354 8.0889 58.0001 18.9451 58.0001 32.1751C58.0001 32.785 57.9784 33.3947 57.9354 33.9935Z",
    fill: "#F1BE48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6705 56L33.0003 51.7098L41.3299 56C49.1963 53.1908 55.2523 46.5159 57.2783 38.2292L53.065 37.5542C51.4593 43.6848 47.1706 48.7154 41.5456 51.285L33.0003 46.8861L24.455 51.285C18.83 48.7154 14.5411 43.6848 12.9355 37.5542L8.72217 38.2292C10.7373 46.5159 16.8041 53.1908 24.6705 56Z",
    fill: "#F1BE48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0798 29.0176V34.56H26.7932V32.5564H28.0109L28.4527 31.3478H26.7932V30.2262H28.8514L29.2932 29.0176H25.0798Z",
    fill: "#F1BE48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5129 29.0176H29.8103V34.5492H31.5129V29.0176Z",
    fill: "#F1BE48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6875 29.0176V34.56H34.39V32.5564H35.6187L36.0603 31.3478H34.39V30.2262H36.459L36.89 29.0176H32.6875Z",
    fill: "#F1BE48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7719 34.5599H40.0475L39.8212 33.8195H37.8925L37.6769 34.5599H35.9958L37.9895 29.0283H39.7565L41.7502 34.5599H41.7719ZM39.5519 32.7524L38.8732 30.4439L38.2159 32.7524H39.5519Z",
    fill: "#F1BE48"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.373 47.9588L42.0927 46.8796L42.3737 47.334L41.8004 47.6975L42.7334 49.2193L42.1601 49.5716L41.2274 48.0495L40.654 48.4129L40.373 47.9588ZM42.3514 46.7207L43.0367 46.2892L44.1944 47.3455L43.7787 45.8233L44.4531 45.4033L45.9031 47.232L45.3521 47.5725L44.4867 46.3912L44.8691 47.879L44.3631 48.1973L43.2167 47.1865L43.8574 48.5153L43.3404 48.8333L42.3624 46.7095L42.3514 46.7207Z",
    fill: "#F1BE48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.81fc11334173e1ea278204d0e76d4caf.svg";
export { ForwardRef as ReactComponent };